import { Action, createReducer, on } from '@ngrx/store';
import type { DrivePickerState } from './drive-picker.models';
import * as DrivePickerActions from './drive-picker.actions';

export const DRIVE_PICKER_FEATURE_KEY = 'drivePicker';

export const initialDrivePickerState: DrivePickerState = {
  selectedFile: null,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialDrivePickerState,
  on(DrivePickerActions.openDrivePicker, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DrivePickerActions.drivePickerFileSelected, (state, { file }) => ({
    ...state,
    selectedFile: file,
    loading: false,
    error: null,
  })),
  on(DrivePickerActions.drivePickerCancelled, (state) => ({
    ...state,
    loading: false,
  })),
  on(DrivePickerActions.drivePickerError, (state, { error }) => ({
    ...state,
    selectedFile: null,
    loading: false,
    error,
  })),
  on(DrivePickerActions.clearDrivePickerSelection, (state) => ({
    ...state,
    selectedFile: null,
    error: null,
  }))
);

export function drivePickerReducer(
  state: DrivePickerState | undefined,
  action: Action
) {
  return reducer(state, action);
}
